var newWindow;
var download_page = '';
document.querySelectorAll('a[href$="dmg"], a[href$="exe"]').forEach(function(item){
    item.addEventListener('click', function(e){
        e.preventDefault();
        window.location.href = item.getAttribute('href');
        if(location.pathname != '/download-guidance/'){
            newWindow = window.open('about:blank','')
            newWindow.location.href = window.location.origin + '/download-guidance/'
        }
    })
});